import React from "react";
import ConfigurationSettingsCard from "../helpers/ConfigurationSettingsCard";
import CustomizationBorderRadiusRow, {
  BorderRadiusFieldEnum,
} from "../helpers/CustomizationBorderRadiusRow";

const ConfigurationSelectionButtonBorderRadiusCard = () => {
  return (
    <ConfigurationSettingsCard title="Selection button border radius">
      <CustomizationBorderRadiusRow
        type={BorderRadiusFieldEnum.SELECTION_BUTTON}
        label="Customize the border radius of selection components in Merge link"
      />
    </ConfigurationSettingsCard>
  );
};

export default ConfigurationSelectionButtonBorderRadiusCard;
